export const getStageRevalidationKey = (stageId: number) => `stage_${stageId}`
